<template>
  <div class="splashscreen connecting">
    <b-row class="main" align-v="center">
      <b-col cols="12" md="6" class="mx-auto text-center">
        <h1>BAĞLANIYOR</h1>
        <h6>Lütfen bekleyiniz..</h6>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "Connecting",
  data() {
    return {
      Interval: null,
      Counter: 0
    };
  },
  async created() {
    this.Interval = await setInterval(async () => {
      await this.Counter++;

      if (this.Counter === 5) {
        window.location.reload();
      }
    }, 1000);
  },
  destroyed() {
    clearInterval(this.Interval);
  }
};
</script>

